Vue.component("user-notifications", {

    props: ["user"],

    data () {
        return {
            form: new AppForm(
                this.user.settings
            ),
            mailboxNotifications: []
        };
    },

    mounted () {

        this.mailboxNotifications = this.mailboxNotificationSettings();

    },

    methods: {

        mailboxNotificationSettings () {

            let mailboxes = [];

            this.user.mailboxes.forEach((mailbox) => {

                mailboxes.push({
                    id: mailbox.id,
                    email: mailbox.email,
                    name: mailbox.name,
                    notify_user: mailbox.pivot.notify_user
                });

            });

            return mailboxes;

        },

        save () {

            this.form.mailboxNotifications = this.mailboxNotifications;
            App.patch("/users/profile/" + this.user.id + "/notifications/update", this.form)
            .then(response => {
                toastr.success("Notification settings saved!");
            })
            .catch(errors => {
                toastr.error("Error saving notification settings. " + errors.message);
            });

        }
    }

});
